import MuiMenuItem from '@mui/material/MenuItem';

export type { MenuItemProps } from '@mui/material/MenuItem';

export const MenuItem = MuiMenuItem;
